import React from "react";

const ServiceSection = (props) => {
    return (
        <div className="service-section animate-fade-up">
            <h3 className="service-section-title">{props.title}</h3>
            {props.children}
        </div>
    );
};

export default ServiceSection;
